import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hidden-fields"
// Manages visibility of normally hidden fields in search forms
export default class extends Controller {
  static targets = ["header", "hiddenField"]

  connect() {
    // Show hidden fields that have data on page load
    this.showFieldsWithData()
  }

  // Double-click header to reveal all hidden fields
  revealAll(event) {
    this.hiddenFieldTargets.forEach(el => {
      el.classList.remove('hide-normally')
    })
  }

  // Show hidden fields that contain filled form elements
  showFieldsWithData() {
    this.hiddenFieldTargets.forEach(el => {
      if (this.hasFilledFields(el)) {
        el.classList.remove('hide-normally')
      }
    })
  }

  hasFilledFields(container) {
    const fields = Array.from(container.querySelectorAll('input[type=text], input[type=number], input[type=date], select, textarea'))
    return fields.some(field => field.value && field.value.trim() !== '')
  }
}
